import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { RestapiService } from './restapi.service';
import { RoutingService } from './routing.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  tk: string;
  visitor: any;
  profile: any;
  profileChanged = new Subject();
  constructor(
    public http: HttpClient,
    public route: RoutingService,
    public api: RestapiService
  ) {
    this.tk = localStorage.getItem('tk');
    this.visitor =  this.getSessionParam('visitor');
    this.profile = this.getSessionParam('profile');
  }
  setSessionParam(key: string, data: any) {
    return localStorage.setItem(key, JSON.stringify(data));
  }

  getSessionParam(param: string) {
    return JSON.parse(localStorage.getItem(param));
  }

  cleanVarSession() {
    return localStorage.clear()
  }
  isLogued() {
    //return true;
    if (this.tk) {
      return true;
    }
    else {
      return false;
    }
  }

  forgotVisitor(){
    localStorage.clear();
    this.visitor = this.getSessionParam('visitor')
  }
  rememberVisitor(value){
    this.setSessionParam('visitor', value );
    this.visitor = this.getSessionParam('visitor')
  }
  isVisitor() {
    //return true;
    if (this.visitor) {
      return true;
    }
    else {
      return false;
    }
  }
  logout() {
    this.profile = null;
    this.tk = null;
    localStorage.clear();
    this.route.goTo('/');
    console.log('Logout');
  }
  login(params: any, redirectOnSuccess?: string, redirectOnError?: string) {
    let options = { url: this.api.route + '/api/authenticate', data: params, method: 'POST', withCredentials: false };
    this.http.post<any>(this.api.route + '/api/authenticate', params, options)
      .subscribe(
        data => {
          console.log('Login res: ', data);
          if (data.token) {
            localStorage.setItem('tk', data.token);
            this.tk = data.token;
            this.getprofile();
            //this.presentToast('Bienvenido', 'success');
            if (redirectOnSuccess) {
              //this.route.goTo('/')
              //this.navCtrl.navigateRoot(redirectOnSuccess);
            }
          }
        },
        resError => {
          console.log('Error res: ', resError)
          switch (resError.error.error) {
            case 'invalid_credentials':
              //this.presentToast('Usuario o contraseña invalidos', 'warning');
              break;
          }
          if (redirectOnError) {
            //this.route.goTo('/')
           // this.navCtrl.navigateRoot(redirectOnError);
          }
        }
      )
  }
  getprofile() {
    if (this.isLogued() === true) {
      const httpOptions = { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem("tk") }) };
      this.http.post<any>(this.api.route + '/api/authenticate/owneraccount', {}, httpOptions)
        .subscribe(
          resData => {
            console.log('user', resData);
            if (resData.profile.geodata === null) {
              resData.profile.geodata = { lat: '', lon: '', marker: {} }
            }
            this.profile = resData.profile;
            this.setSessionParam('profile', this.profile);
            this.profileChanged.next(this.profile);
          },
          error => {
            console.log('getprofile', error.error);
            if (error.error.error == 'user_not_found') {
              localStorage.clear();
              //this.presentToast('Usuario invalido', 'warning');
              this.logout();
            }
            if (error.error.error == 'token_expired') {
              localStorage.clear();
              //this.presentToast('Sesion expirada', 'warning');
              this.logout();
            }
            if (error.error.error == 'token_not_provided') {
              localStorage.clear();
            }
            // localStorage.clear();
          }
        );
    }

  }
  signin(params: object) {
    console.log('signin http', params);
    return this.http.post<any>(this.api.route + '/api/authenticate/signin', params)
  }

  resetpass(params: object) {
    const httpOptions = { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem("tk") }) };
    params['tk'] = localStorage.getItem("tk");
    console.log('resetPass http', params, httpOptions);
    /*this.http.post<any>(this.api.route + '/api/authenticate/resetpassword', params, httpOptions)
    .subscribe(resData => {
      console.log('resetPass resData', resData);
    });*/
  }

  forgotpass(params: object) {
    console.log('forgotpass', params);
    /*this.http.post<any>(this.api.route + '/api/authenticate/forgotpassword', params)
    .subscribe(resData => {
      console.log('forgotpass resData', resData);
    });*/
  }

  activate(params: object) {
    console.log('activate params', params);
    return this.http.post<any>(this.api.route + '/api/authenticate/activateuser', params)
  }
}
